import { render, staticRenderFns } from "./sensitive-sheet.vue?vue&type=template&id=15d19ce9&scoped=true&"
import script from "./sensitive-sheet.vue?vue&type=script&lang=js&"
export * from "./sensitive-sheet.vue?vue&type=script&lang=js&"
import style0 from "./sensitive-sheet.vue?vue&type=style&index=0&id=15d19ce9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d19ce9",
  null
  
)

export default component.exports